<template>
    <div>
        <table width="480" cellpadding="0" border="0" align="center">
            <tbody>
                <tr>
                    <td>
                        <div class="logoImg"></div>
                    </td>
                </tr>
                <tr>
                    <td class="errorTd">
                        <div class="errorHeader">
                            <h2 class="errorTitle">{{$t('errorPage.title')}}</h2>
                            <span class="errorMessage">{{$t('errorPage.message')}}</span>
                            <div class="errorLink">
                                <a class="errorLinkA" href="PG010MainPage?pageNo=1" title="トップページ">トップページへ</a>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import SiteConstants from 'assets/const/SiteConstants.json';
export default {
    name: 'ErrorPage',
    data() {
        return {
            SiteConstants: SiteConstants
        }
    },
    created(){
        const url = './'+this.SiteConstants.PG010MAIN + "?pageNo=1";
        history.pushState(null,null,url);
    }
}
</script>

<style scoped>

</style>
